export default "__VITE_ASSET__CjCCO4A9__"